module.exports = __webpack_public_path__ + "img/storyoflife_pic.6cb71d5b.png";